var _defs, _g, _g2, _rect, _rect2, _rect3, _g3, _rect4, _rect5, _rect6, _g4, _rect7, _rect8, _rect9, _path, _line, _path2, _line2, _path3, _line3, _path4, _line4, _rect10, _rect11, _rect12, _rect13, _g5, _path5, _rect14, _rect15, _g6, _path6, _line5, _path7, _line6, _path8, _line7, _path9, _line8, _rect16, _rect17, _rect18, _rect19, _g7, _path10, _g8, _path11, _line9, _path12, _line10, _path13, _line11, _path14, _line12, _rect20, _g9, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _g10, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _path15, _path16, _rect53, _rect54, _rect55, _g11, _rect56, _path17, _path18, _path19, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTesting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_839",
    "data-name": "Group 839",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 114.452,
    height: 87.686,
    viewBox: "0 0 114.452 87.686",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_424",
    "data-name": "Rectangle 424",
    width: 114.452,
    height: 87.686
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_789",
    "data-name": "Group 789"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_787",
    "data-name": "Group 787",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M132.328,32.657a4.952,4.952,0,1,1,7.009,0,4.956,4.956,0,0,1-7.009,0m9.018,5.948,4.072-4.072-2.489-2.489A.107.107,0,0,1,142.95,32L146.383,32V26.25h-3.459a.576.576,0,0,0-.037-.08l2.4-2.4L141.213,19.7l-2.4,2.4a1.1,1.1,0,0,0-.139-.064v-3.3l-5.751.005v3.326a1.761,1.761,0,0,0-.176.08l-2.3-2.3-4.072,4.072,2.35,2.35a1.812,1.812,0,0,1-.064.181H125.41V32.2h3.384a1.007,1.007,0,0,1,.059.133l-2.34,2.34,4.072,4.072,2.452-2.452a.7.7,0,0,0,.08.027l-.005,3.39h5.756V36.185c.016-.005.027-.016.037-.016Z",
    transform: "translate(-58.569 -8.747)",
    fill: "#140578"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_788",
    "data-name": "Group 788",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M151.773,5.554A2.646,2.646,0,1,1,154.422,8.2a2.644,2.644,0,0,1-2.649-2.649m1.162,5.66h3.075V9.332a.041.041,0,0,1,.027-.011l1.3,1.3,2.175-2.175L158.2,7.131a.22.22,0,0,0,.016-.043h1.812V4.019h-1.812c-.011-.027-.016-.053-.027-.075L159.437,2.7,157.262.522,156,1.78a.713.713,0,0,0-.1-.037V0h-3.075V1.775a.694.694,0,0,1-.091.043L151.512.586l-2.175,2.175,1.279,1.279c-.011.027-.016.048-.027.075h-1.77V7.19h1.855a.318.318,0,0,0,.021.043l-1.284,1.279,2.175,2.175,1.332-1.332c.011.005.016.005.021.011v1.849Z",
    transform: "translate(-69.502)",
    fill: "#140578"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_796",
    "data-name": "Group 796"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_790",
    "data-name": "Group 790",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M41.1,49.949H5.959a.709.709,0,0,1-.709-.709V27.489a.709.709,0,0,1,.709-.709H41.1a.709.709,0,0,1,.709.709V49.24a.7.7,0,0,1-.709.709",
    transform: "translate(-2.452 -12.507)",
    fill: "#140578"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_791",
    "data-name": "Group 791",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M6.2,50.451V30.87a.56.56,0,0,1,.56-.56H41.2a.56.56,0,0,1,.56.56V50.451a.56.56,0,0,1-.56.56H6.76a.56.56,0,0,1-.56-.56",
    transform: "translate(-2.896 -14.155)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_792",
    "data-name": "Group 792",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M71.657,28.134a.464.464,0,1,1-.464-.464.464.464,0,0,1,.464.464",
    transform: "translate(-33.032 -12.922)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_793",
    "data-name": "Group 793",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M68.787,28.134a.464.464,0,1,1-.464-.464.464.464,0,0,1,.464.464",
    transform: "translate(-31.692 -12.922)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_794",
    "data-name": "Group 794",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M65.917,28.134a.464.464,0,1,1-.464-.464.464.464,0,0,1,.464.464",
    transform: "translate(-30.352 -12.922)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_795",
    "data-name": "Group 795",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M12.332,35.621a1.871,1.871,0,1,1-1.871-1.871,1.87,1.87,0,0,1,1.871,1.871",
    transform: "translate(-4.012 -15.762)",
    fill: "#ffcc6e"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_432",
    "data-name": "Rectangle 432",
    width: 27.912,
    height: 0.885,
    transform: "translate(9.178 17.999)",
    fill: "#d6d4eb"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_433",
    "data-name": "Rectangle 433",
    width: 19.001,
    height: 0.885,
    transform: "translate(9.178 19.416)",
    fill: "#d6d4eb"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_434",
    "data-name": "Rectangle 434",
    width: 9.881,
    height: 0.885,
    transform: "translate(9.178 20.919)",
    fill: "#d6d4eb"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_798",
    "data-name": "Group 798"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_797",
    "data-name": "Group 797",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M12.332,46.811a1.871,1.871,0,1,1-1.871-1.871,1.87,1.87,0,0,1,1.871,1.871",
    transform: "translate(-4.012 -20.988)",
    fill: "#3da1b8"
  })))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_436",
    "data-name": "Rectangle 436",
    width: 27.912,
    height: 0.885,
    transform: "translate(9.178 23.963)",
    fill: "#d6d4eb"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_437",
    "data-name": "Rectangle 437",
    width: 19.001,
    height: 0.885,
    transform: "translate(9.178 25.38)",
    fill: "#d6d4eb"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_438",
    "data-name": "Rectangle 438",
    width: 9.881,
    height: 0.885,
    transform: "translate(9.178 26.878)",
    fill: "#d6d4eb"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_800",
    "data-name": "Group 800"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_799",
    "data-name": "Group 799",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M12.332,57.991a1.871,1.871,0,1,1-1.871-1.871,1.87,1.87,0,0,1,1.871,1.871",
    transform: "translate(-4.012 -26.209)",
    fill: "#ff5e63"
  })))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_440",
    "data-name": "Rectangle 440",
    width: 27.912,
    height: 0.885,
    transform: "translate(9.178 29.927)",
    fill: "#d6d4eb"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_441",
    "data-name": "Rectangle 441",
    width: 19.001,
    height: 0.885,
    transform: "translate(9.178 31.339)",
    fill: "#d6d4eb"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_442",
    "data-name": "Rectangle 442",
    width: 9.881,
    height: 0.885,
    transform: "translate(9.178 32.842)",
    fill: "#d6d4eb"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M76.685,73.5v.48H76.2",
    transform: "translate(-35.587 -34.326)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_88",
    "data-name": "Line 88",
    x1: 37.9,
    transform: "translate(1.754 39.654)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "2.967 2.967"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M1.965,73.98H1.48V73.5",
    transform: "translate(-0.691 -34.326)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_89",
    "data-name": "Line 89",
    y1: 24.938,
    transform: "translate(0.789 13.255)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "3.058 3.058"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M1.48,23.525V23.04h.485",
    transform: "translate(-0.691 -10.76)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_90",
    "data-name": "Line 90",
    x2: 37.9,
    transform: "translate(2.233 12.28)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "2.967 2.967"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M76.2,23.04h.485v.485",
    transform: "translate(-35.587 -10.76)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line_91",
    "data-name": "Line 91",
    y2: 24.943,
    transform: "translate(41.098 13.74)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "3.058 3.058"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_443",
    "data-name": "Rectangle 443",
    width: 1.578,
    height: 1.578,
    transform: "translate(0 11.491)",
    fill: "#140578"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_444",
    "data-name": "Rectangle 444",
    width: 1.578,
    height: 1.578,
    transform: "translate(0 38.865)",
    fill: "#140578"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_445",
    "data-name": "Rectangle 445",
    width: 1.578,
    height: 1.578,
    transform: "translate(40.309 11.491)",
    fill: "#140578"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_446",
    "data-name": "Rectangle 446",
    width: 1.578,
    height: 1.578,
    transform: "translate(40.309 38.865)",
    fill: "#38366e"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_807",
    "data-name": "Group 807"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_801",
    "data-name": "Group 801",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M185.341,131.837H158.559a.709.709,0,0,1-.709-.709V112.959a.709.709,0,0,1,.709-.709h26.782a.709.709,0,0,1,.709.709v18.169a.709.709,0,0,1-.709.709",
    transform: "translate(-73.719 -52.423)",
    fill: "#140578"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_802",
    "data-name": "Group 802",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M158.65,132.28v-16.6a.453.453,0,0,1,.453-.453h26.446a.453.453,0,0,1,.453.453v16.6a.453.453,0,0,1-.453.453H159.1a.453.453,0,0,1-.453-.453",
    transform: "translate(-74.093 -53.815)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_803",
    "data-name": "Group 803",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M208.908,113.4a.389.389,0,1,1-.389-.389.388.388,0,0,1,.389.389",
    transform: "translate(-97.201 -52.778)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_804",
    "data-name": "Group 804",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M206.478,113.4a.389.389,0,1,1-.389-.389.388.388,0,0,1,.389.389",
    transform: "translate(-96.066 -52.778)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_805",
    "data-name": "Group 805",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M204.058,113.4a.389.389,0,1,1-.389-.389.388.388,0,0,1,.389.389",
    transform: "translate(-94.936 -52.778)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_806",
    "data-name": "Group 806",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M184.813,128.091a4.061,4.061,0,1,1-4.061-4.061,4.06,4.06,0,0,1,4.061,4.061",
    transform: "translate(-82.518 -57.925)",
    fill: "#9c2eff"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M185.473,129.749l-1.881,1.087-1.881,1.082V127.58l1.881,1.082Z",
    transform: "translate(-84.862 -59.583)",
    fill: "#fff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_453",
    "data-name": "Rectangle 453",
    width: 27.347,
    height: 0.538,
    transform: "translate(84.557 77.079)",
    fill: "#d6d4eb"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_454",
    "data-name": "Rectangle 454",
    width: 6.161,
    height: 0.538,
    transform: "translate(84.557 77.079)",
    fill: "#f2a61c"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_809",
    "data-name": "Group 809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_808",
    "data-name": "Group 808",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    d: "M170.261,144.766a.416.416,0,1,1-.416-.416.416.416,0,0,1,.416.416",
    transform: "translate(-79.127 -67.414)",
    fill: "#f2a61c"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M213.17,151.19v.485h-.48",
    transform: "translate(-99.33 -70.609)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "Line_92",
    "data-name": "Line 92",
    x1: 28.781,
    transform: "translate(83.598 81.066)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "3.066 3.066"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    d: "M155.505,151.675h-.485v-.485",
    transform: "translate(-72.397 -70.609)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "Line_93",
    "data-name": "Line 93",
    y1: 20.163,
    transform: "translate(82.623 59.48)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "2.912 2.912"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M155.02,110.3v-.485h.485",
    transform: "translate(-72.397 -51.284)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    id: "Line_94",
    "data-name": "Line 94",
    x2: 28.786,
    transform: "translate(84.083 58.526)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "3.066 3.066"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M212.69,109.81h.48v.485",
    transform: "translate(-99.33 -51.284)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    id: "Line_95",
    "data-name": "Line 95",
    y2: 20.163,
    transform: "translate(113.839 59.949)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "2.912 2.912"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_456",
    "data-name": "Rectangle 456",
    width: 1.221,
    height: 1.221,
    transform: "translate(82.015 57.914)",
    fill: "#38366e"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_457",
    "data-name": "Rectangle 457",
    width: 1.221,
    height: 1.221,
    transform: "translate(82.015 80.453)",
    fill: "#38366e"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_458",
    "data-name": "Rectangle 458",
    width: 1.221,
    height: 1.221,
    transform: "translate(113.232 57.914)",
    fill: "#38366e"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_459",
    "data-name": "Rectangle 459",
    width: 1.221,
    height: 1.221,
    transform: "translate(113.232 80.453)",
    fill: "#38366e"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_814",
    "data-name": "Group 814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_812",
    "data-name": "Group 812",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M188.393,99.988a7.957,7.957,0,0,0,.714-1.839V94.221a.821.821,0,0,1,.821-.821h10.329a.821.821,0,0,1,.821.821V98.4a.821.821,0,0,1-.821.821h-9.78a3.525,3.525,0,0,1-1.855,1.087.215.215,0,0,1-.229-.32",
    transform: "translate(-87.969 -43.62)",
    fill: "#140578"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_813",
    "data-name": "Group 813",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M204.382,95.956a2.193,2.193,0,0,0,2.494,0,1.254,1.254,0,0,1,.624,1.221,1.922,1.922,0,0,1-.677,1.247,4.243,4.243,0,0,1-1.2.709,4.451,4.451,0,0,1-1.2-.709,1.945,1.945,0,0,1-.677-1.247,1.28,1.28,0,0,1,.634-1.221",
    transform: "translate(-95.153 -44.769)",
    fill: "#fff"
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M192.765,96.69v2.4h-.682V97.212h-.442V96.69Z",
    transform: "translate(-89.5 -45.156)",
    fill: "#fff"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_822",
    "data-name": "Group 822"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_815",
    "data-name": "Group 815",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M195.758,98.37a1.425,1.425,0,0,0,0-1.055.311.311,0,0,0-.549,0,1.425,1.425,0,0,0,0,1.055.311.311,0,0,0,.549,0m-.826.576a.973.973,0,0,1-.378-.432,1.525,1.525,0,0,1-.133-.672,1.541,1.541,0,0,1,.133-.672,1,1,0,0,1,.378-.432,1.045,1.045,0,0,1,.549-.149.993.993,0,0,1,.544.149,1,1,0,0,1,.378.432,1.525,1.525,0,0,1,.133.672,1.622,1.622,0,0,1-.133.672.99.99,0,0,1-.922.581,1.059,1.059,0,0,1-.549-.149",
    transform: "translate(-90.798 -45.11)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_816",
    "data-name": "Group 816",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M200.168,98.37a1.425,1.425,0,0,0,0-1.055.311.311,0,0,0-.549,0,1.425,1.425,0,0,0,0,1.055.311.311,0,0,0,.549,0m-.826.576a.973.973,0,0,1-.378-.432,1.525,1.525,0,0,1-.133-.672,1.541,1.541,0,0,1,.133-.672,1,1,0,0,1,.378-.432,1.045,1.045,0,0,1,.549-.149.992.992,0,0,1,.544.149,1,1,0,0,1,.378.432,1.525,1.525,0,0,1,.133.672,1.622,1.622,0,0,1-.133.672.99.99,0,0,1-.922.581,1.073,1.073,0,0,1-.549-.149",
    transform: "translate(-92.858 -45.11)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_817",
    "data-name": "Group 817",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M113.525,91.535H47.446a1.476,1.476,0,0,1-1.476-1.476V52.7a1.476,1.476,0,0,1,1.476-1.476h66.079A1.476,1.476,0,0,1,115,52.7V90.058a1.476,1.476,0,0,1-1.476,1.476",
    transform: "translate(-21.469 -23.921)",
    fill: "#140578"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_818",
    "data-name": "Group 818",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M47.76,92.651V58.78a.892.892,0,0,1,.89-.89H114a.892.892,0,0,1,.89.89V92.651a.892.892,0,0,1-.89.89H48.65a.888.888,0,0,1-.89-.89",
    transform: "translate(-22.305 -27.036)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_819",
    "data-name": "Group 819",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M171.338,53.794a.874.874,0,1,1-.874-.874.871.871,0,0,1,.874.874",
    transform: "translate(-79.202 -24.715)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_820",
    "data-name": "Group 820",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M165.918,53.794a.874.874,0,1,1-.874-.874.871.871,0,0,1,.874.874",
    transform: "translate(-76.671 -24.715)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_821",
    "data-name": "Group 821",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M160.5,53.794a.874.874,0,1,1-.874-.874.871.871,0,0,1,.874.874",
    transform: "translate(-74.139 -24.715)",
    fill: "#fff"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M98.445,95.08v.485H97.96",
    transform: "translate(-45.749 -44.404)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    id: "Line_96",
    "data-name": "Line 96",
    x1: 23.067,
    transform: "translate(28.163 51.161)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "3.059 3.059"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M51.5,95.565H51.01V95.08",
    transform: "translate(-23.823 -44.404)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    id: "Line_97",
    "data-name": "Line 97",
    y1: 15.813,
    transform: "translate(27.187 33.839)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "3.114 3.114"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M51.01,62.11v-.48H51.5",
    transform: "translate(-23.823 -28.782)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    id: "Line_98",
    "data-name": "Line 98",
    x2: 23.067,
    transform: "translate(28.653 32.848)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "3.059 3.059"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M97.96,61.63h.485v.48",
    transform: "translate(-45.749 -28.782)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    id: "Line_99",
    "data-name": "Line 99",
    y2: 15.813,
    transform: "translate(52.696 34.351)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "3.114 3.114"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_469",
    "data-name": "Rectangle 469",
    width: 25.508,
    height: 18.313,
    transform: "translate(30.167 35.795)",
    fill: "#140578"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_824",
    "data-name": "Group 824"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_823",
    "data-name": "Group 823",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    d: "M75.115,73.4a2.18,2.18,0,1,1-2.18-2.18A2.179,2.179,0,0,1,75.115,73.4Zm6.748,12.5H59.6l7.014-13.229,5.271,9.087,3.576-3.773Z",
    transform: "translate(-27.834 -33.261)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })))), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_471",
    "data-name": "Rectangle 471",
    width: 31.776,
    height: 1.956,
    transform: "translate(58.612 33.13)",
    fill: "#d6d4eb"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_472",
    "data-name": "Rectangle 472",
    width: 9.13,
    height: 0.975,
    transform: "translate(58.612 36.728)",
    fill: "#d6d4eb"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_473",
    "data-name": "Rectangle 473",
    width: 3.704,
    height: 0.975,
    transform: "translate(68.989 36.728)",
    fill: "#d6d4eb"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_474",
    "data-name": "Rectangle 474",
    width: 9.727,
    height: 0.975,
    transform: "translate(74.116 36.728)",
    fill: "#d6d4eb"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_475",
    "data-name": "Rectangle 475",
    width: 5.778,
    height: 0.975,
    transform: "translate(84.611 36.728)",
    fill: "#d6d4eb"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_476",
    "data-name": "Rectangle 476",
    width: 12.04,
    height: 0.975,
    transform: "translate(58.612 39.163)",
    fill: "#d6d4eb"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_477",
    "data-name": "Rectangle 477",
    width: 4.685,
    height: 0.975,
    transform: "translate(71.984 39.163)",
    fill: "#d6d4eb"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_478",
    "data-name": "Rectangle 478",
    width: 4.685,
    height: 0.975,
    transform: "translate(77.735 39.163)",
    fill: "#d6d4eb"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_479",
    "data-name": "Rectangle 479",
    width: 5.948,
    height: 0.975,
    transform: "translate(83.145 39.163)",
    fill: "#d6d4eb"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_480",
    "data-name": "Rectangle 480",
    width: 3.352,
    height: 0.975,
    transform: "translate(58.612 41.599)",
    fill: "#d6d4eb"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_481",
    "data-name": "Rectangle 481",
    width: 6.017,
    height: 0.975,
    transform: "translate(74.324 41.599)",
    fill: "#d6d4eb"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_482",
    "data-name": "Rectangle 482",
    width: 10.585,
    height: 0.975,
    transform: "translate(62.732 41.599)",
    fill: "#d6d4eb"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_483",
    "data-name": "Rectangle 483",
    width: 7.59,
    height: 0.975,
    transform: "translate(58.612 44.035)",
    fill: "#d6d4eb"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_484",
    "data-name": "Rectangle 484",
    width: 2.548,
    height: 0.975,
    transform: "translate(67.507 44.035)",
    fill: "#d6d4eb"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_485",
    "data-name": "Rectangle 485",
    width: 5.01,
    height: 0.975,
    transform: "translate(71.243 44.035)",
    fill: "#d6d4eb"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_486",
    "data-name": "Rectangle 486",
    width: 2.905,
    height: 0.975,
    transform: "translate(58.612 46.465)",
    fill: "#d6d4eb"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_487",
    "data-name": "Rectangle 487",
    width: 6.374,
    height: 0.975,
    transform: "translate(62.615 46.465)",
    fill: "#d6d4eb"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_488",
    "data-name": "Rectangle 488",
    width: 28.493,
    height: 8.474,
    transform: "translate(27.187 56.053)",
    fill: "#d6d4eb"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_489",
    "data-name": "Rectangle 489",
    width: 5.41,
    height: 5.031,
    transform: "translate(27.944 56.629)",
    fill: "#fff"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_490",
    "data-name": "Rectangle 490",
    width: 5.41,
    height: 1.492,
    transform: "translate(27.944 62.407)",
    fill: "#fff"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_491",
    "data-name": "Rectangle 491",
    width: 5.41,
    height: 5.031,
    transform: "translate(34.836 58.873)",
    fill: "#fff"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_492",
    "data-name": "Rectangle 492",
    width: 5.41,
    height: 1.492,
    transform: "translate(34.836 56.629)",
    fill: "#fff"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_493",
    "data-name": "Rectangle 493",
    width: 5.41,
    height: 5.031,
    transform: "translate(42.26 56.629)",
    fill: "#fff"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_494",
    "data-name": "Rectangle 494",
    width: 5.41,
    height: 1.492,
    transform: "translate(42.26 62.407)",
    fill: "#fff"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_495",
    "data-name": "Rectangle 495",
    width: 5.41,
    height: 5.031,
    transform: "translate(49.146 58.873)",
    fill: "#fff"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_496",
    "data-name": "Rectangle 496",
    width: 5.41,
    height: 1.492,
    transform: "translate(49.146 56.629)",
    fill: "#fff"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_827",
    "data-name": "Group 827"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_825",
    "data-name": "Group 825",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M143.285,94.043H111.21V92.956a.666.666,0,0,1,.666-.666h30.742a.666.666,0,0,1,.666.666Z",
    transform: "translate(-51.937 -43.101)",
    fill: "#140578"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_826",
    "data-name": "Group 826",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    d: "M143.285,94.34H111.21v13.607a.875.875,0,0,0,.874.874h30.321a.875.875,0,0,0,.874-.874V94.34Zm-.325.325v13.282a.557.557,0,0,1-.554.554H112.084a.557.557,0,0,1-.554-.554V94.665Z",
    transform: "translate(-51.937 -44.059)",
    fill: "#140578"
  })))), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_499",
    "data-name": "Rectangle 499",
    width: 19.496,
    height: 11.64,
    transform: "translate(70.444 52.024)",
    fill: "#d6d4eb"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_500",
    "data-name": "Rectangle 500",
    width: 17.503,
    height: 1.189,
    transform: "translate(71.483 52.642)",
    fill: "#fff"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_501",
    "data-name": "Rectangle 501",
    width: 17.503,
    height: 0.592,
    transform: "translate(71.483 54.545)",
    fill: "#fff"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_502",
    "data-name": "Rectangle 502",
    width: 4.035,
    height: 1.391,
    transform: "translate(65.274 54.545)",
    fill: "#d6d4eb"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_503",
    "data-name": "Rectangle 503",
    width: 3.763,
    height: 7.121,
    transform: "translate(71.483 55.675)",
    fill: "#fff"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_504",
    "data-name": "Rectangle 504",
    width: 3.763,
    height: 7.121,
    transform: "translate(80.731 55.675)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M143.055,111.271H146.5v-6.8h-3.443Zm3.763.325H142.73V104.15h4.088Z",
    transform: "translate(-66.658 -48.64)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M159.92,111.271h3.443v-6.8H159.92Zm3.768.325H159.6V104.15h4.088Z",
    transform: "translate(-74.536 -48.64)",
    fill: "#fff"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_505",
    "data-name": "Rectangle 505",
    width: 4.035,
    height: 1.391,
    transform: "translate(65.274 57.061)",
    fill: "#d6d4eb"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_506",
    "data-name": "Rectangle 506",
    width: 4.035,
    height: 1.391,
    transform: "translate(65.274 59.582)",
    fill: "#d6d4eb"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_507",
    "data-name": "Rectangle 507",
    width: 4.035,
    height: 1.391,
    transform: "translate(65.274 62.097)",
    fill: "#d6d4eb"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_838",
    "data-name": "Group 838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_828",
    "data-name": "Group 828",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M99.725,24.21H88.074a2.8,2.8,0,0,0-2.478,4.1l-.911,1.658a.5.5,0,0,0,.629.7l2.175-.922a2.622,2.622,0,0,0,.581.064H99.719a2.8,2.8,0,0,0,.005-5.6",
    transform: "translate(-39.519 -11.307)",
    fill: "#140578"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_829",
    "data-name": "Group 829",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M92.193,28.631a.991.991,0,1,1-.991-.991.989.989,0,0,1,.991.991",
    transform: "translate(-42.13 -12.908)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_830",
    "data-name": "Group 830",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M98.973,28.631a.991.991,0,1,1-.991-.991.989.989,0,0,1,.991.991",
    transform: "translate(-45.296 -12.908)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_831",
    "data-name": "Group 831",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M105.753,28.631a.991.991,0,1,1-.991-.991.989.989,0,0,1,.991.991",
    transform: "translate(-48.463 -12.908)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_832",
    "data-name": "Group 832",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    d: "M112.533,28.631a.991.991,0,1,1-.991-.991.989.989,0,0,1,.991.991",
    transform: "translate(-51.629 -12.908)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_833",
    "data-name": "Group 833",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M180.915,77.44H169.264a2.8,2.8,0,0,0-2.8,2.8h0a2.811,2.811,0,0,0,.32,1.3l-.911,1.658a.5.5,0,0,0,.629.7l2.175-.922a2.623,2.623,0,0,0,.581.064h11.651a2.8,2.8,0,0,0,2.8-2.8h0a2.79,2.79,0,0,0-2.793-2.8",
    transform: "translate(-77.436 -36.166)",
    fill: "#140578"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_834",
    "data-name": "Group 834",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M173.383,81.851a.991.991,0,1,1-.991-.991.989.989,0,0,1,.991.991",
    transform: "translate(-80.047 -37.763)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_835",
    "data-name": "Group 835",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M180.163,81.851a.991.991,0,1,1-.991-.991.989.989,0,0,1,.991.991",
    transform: "translate(-83.214 -37.763)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_836",
    "data-name": "Group 836",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M186.943,81.851a.991.991,0,1,1-.991-.991.989.989,0,0,1,.991.991",
    transform: "translate(-86.38 -37.763)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_837",
    "data-name": "Group 837",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M193.723,81.851a.991.991,0,1,1-.991-.991.989.989,0,0,1,.991.991",
    transform: "translate(-89.546 -37.763)",
    fill: "#fff"
  })))), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_518",
    "data-name": "Rectangle 518",
    width: 18.75,
    height: 4.839,
    transform: "translate(4.296 45.021)",
    fill: "#9c2eff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M15.532,85.93l-1.167,3.219h-.9l-.725-2-.746,2h-.9L9.93,85.93h.879l.762,2.18.789-2.18h.794l.767,2.18.783-2.18Z",
    transform: "translate(-4.638 -40.131)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M25.912,85.93l-1.167,3.219h-.9l-.725-2-.746,2h-.9L20.31,85.93h.885l.757,2.18.794-2.18h.789l.767,2.18.783-2.18Z",
    transform: "translate(-9.485 -40.131)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M36.3,85.93l-1.167,3.219h-.9l-.725-2-.746,2h-.9L30.7,85.93h.879l.757,2.18.794-2.18h.789l.767,2.18.783-2.18Z",
    transform: "translate(-14.338 -40.131)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M7.191,84.47v4.839m-.991.005H8.188M6.2,84.47H8.188",
    transform: "translate(-2.896 -39.449)",
    fill: "none",
    stroke: "#38366e",
    strokeMiterlimit: 10,
    strokeWidth: 2.098
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    d: "M103.063,84.069l-1.642-.442L99.78,83.19l.437,1.642.442,1.642.9-.9,1.876,1.876.6-.6-1.876-1.876Z",
    transform: "translate(-46.599 -38.851)",
    fill: "#f2a61c"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTesting);
export default __webpack_public_path__ + "static/media/testing.3dac92ed1320814ff9be7eca3c50fed7.svg";
export { ForwardRef as ReactComponent };